module.exports = __webpack_public_path__ + "static/media/North grove 3.596caa64.jpg";